import { render, staticRenderFns } from "./PropertyRequest.vue?vue&type=template&id=ff10216a&scoped=true&"
import script from "./PropertyRequest.vue?vue&type=script&lang=js&"
export * from "./PropertyRequest.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRequest.vue?vue&type=style&index=0&id=ff10216a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff10216a",
  null
  
)

export default component.exports